import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Property } from 'app/modules/projects/projects.types';
import { AccountService } from 'app/core';
import { PropertyDealsService } from './deals.service';
import { PropertiesService } from '../../properties.service';
import { JupiterState } from 'app/modules/jupiter/@store/state';
import { Store } from '@ngxs/store';

@Injectable({
  providedIn: 'root',
})
export class NearbyPropertyResolver {
  constructor(
    private _propertyNearbyService: PropertyDealsService,
    private _propertiesService: PropertiesService,
    private _accountService: AccountService,
    private readonly store: Store,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._propertyNearbyService.accountId = accountData.id;
    });

    this._propertiesService.property$.subscribe((property: Property) => {
      if (this.store.selectSnapshot(JupiterState.getEntity)) {
        this._propertyNearbyService.property = store.selectSnapshot(JupiterState.getEntity) as Property;
        return;
      }

      this._propertyNearbyService.property = property;
    });
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Property {
    return this._propertyNearbyService.property;
  }
}
